
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * GatewayExecutionType enum
 */
class GatewayExecutionType {
  /**
   * Initialize enum with a given value
   * @param {GatewayExecutionType|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof GatewayExecutionType) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!GatewayExecutionType}
   * @param {!GatewayExecutionType} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof GatewayExecutionType)) {
      throw new TypeError('Instance of GatewayExecutionType is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!GatewayExecutionType}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!GatewayExecutionType}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === GatewayExecutionType.PLACED.value) {
      return 'PLACED'
    }
    if (this.value === GatewayExecutionType.CANCELED.value) {
      return 'CANCELED'
    }
    if (this.value === GatewayExecutionType.EXPIRED.value) {
      return 'EXPIRED'
    }
    if (this.value === GatewayExecutionType.REJECTED.value) {
      return 'REJECTED'
    }
    if (this.value === GatewayExecutionType.FILLED.value) {
      return 'FILLED'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!GatewayExecutionType}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!GatewayExecutionType}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!GatewayExecutionType} Created enum
   */
  static fromObject (other) {
    return new GatewayExecutionType(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
GatewayExecutionType.PLACED = new GatewayExecutionType(0 + 0)
// noinspection PointlessArithmeticExpressionJS
GatewayExecutionType.CANCELED = new GatewayExecutionType(0 + 1)
// noinspection PointlessArithmeticExpressionJS
GatewayExecutionType.EXPIRED = new GatewayExecutionType(0 + 2)
// noinspection PointlessArithmeticExpressionJS
GatewayExecutionType.REJECTED = new GatewayExecutionType(0 + 3)
// noinspection PointlessArithmeticExpressionJS
GatewayExecutionType.FILLED = new GatewayExecutionType(0 + 4)

export { GatewayExecutionType };

/**
 * Fast Binary Encoding GatewayExecutionType field model
 */
class FieldModelGatewayExecutionType extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelGatewayExecutionType}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelGatewayExecutionType}
   * @param {GatewayExecutionType=} defaults Default value, defaults is new GatewayExecutionType()
   * @returns {!GatewayExecutionType} Result value
   */
  get (defaults = new GatewayExecutionType()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new GatewayExecutionType(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelGatewayExecutionType}
   * @param {!GatewayExecutionType} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelGatewayExecutionType };
